import { forwardRef, Ref, useImperativeHandle, useState } from "react"
import { BaseInput } from "../../../../../../../../../components"
import { onChange } from "../../../../../../../../../utils/types"
import { CancelActivityProps, CancelActivityRef } from "./types"
import { useTranslation } from "react-i18next"
import { Box } from "@mui/material"
import { FooterSimple } from "../../../../../../../../../components/buttons/footer"

export const CancelActivity = forwardRef(({ cancel, confirm }: CancelActivityProps, ref: Ref<CancelActivityRef>) => {
    const { t } = useTranslation()
    const [loading, setLoading] = useState(false)
    const [value, setValue] = useState({ input: { reason: { value: '', label: '', }, }, })
    const onChange: onChange = ({ target }) => {
        const { name, value } = target
        setValue((prev) => ({
            ...prev,
            input: {
                [name as 'reason']: {
                    ...prev.input[name as 'reason'],
                    value,
                },
            },
        }))
    }

    useImperativeHandle(ref, () => ({
        getData: { reason: value?.input?.reason?.value ?? '' },
        loading: (value) => {setLoading(() => value)}
    }))
    return (
        <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 2 }}>
            <BaseInput
                fullWidth
                sx={{ width: '100%' }}
                name="reason"
                placeholder={t('general.cancelReasonLabel', {postProcess: ['required']})}
                label={t('general.cancelReasonLabel', {postProcess: ['required']})}
                onChange={onChange}
                value={value.input}
                type="alphaNumeric"
                multiline
                rows={4}
            />

            <FooterSimple
                cancel={{
                    children: t('general.cancel'),
                    onClick: cancel
                }}
                confirm={{
                    children: t('general.cancelActivity'),
                    loading: loading,
                    disabled: !value.input.reason.value,
                    onClick: confirm,
                    variant: 'primary_c'
                }}
            />
        </Box>
    )
})